import { get } from 'lodash'
import { isAndroid, isTBS } from './UA'
import TBSDownload from './tbs-download'
import { APP_INFO, OPEN_API } from './constant'
import { wxDownloadApi, wxDownloadTask, detectStatus } from './appdownloadUtil'
import { reportUg, statTicket } from './stat'
import { detectEnv } from './yUtil';
import actions from '../store/actions'
import { getArticleIdFromUrl } from './index'
import store from '../store'
import { lclog } from '../utils/lclog';
import { parseUrl } from '../utils/url';

/**
 * 支持拉新拉活下载\唤起软件方法，浏览器、快报
 * @param {name} param 需要拉新拉活软件名称，默认浏览器
 * @param {url} param 调起url
 * @param {isNeedPause} param 是否暂停
 * @param {isBackUrl} param 是否设置backurl
 * @param {appInfo} param App相关信息，支持自定义参入
 * @param {statData} param 上报自定义参数
 */

let tbsDataReport = {
  startDownloadTime: new Date().getTime(),
  startInstallTime: new Date().getTime(),
  startInstallPackageTime: new Date().getTime(),
}
let tbsDownloadPause = false; // 标志是否点击暂停
//正文后独立运营位 TBS当前页直接下载，拉活则直接调起QB；非TBS和IOS跳转下载中间页
export const directDownload = async ({ name = 'qb', url = '', isNeedPause = false, isBackUrl = true, appInfo = '', docId = getArticleIdFromUrl(), statData = {}, posId, subpos }) => {
  const myEnv = detectEnv()
  name = name.toLocaleLowerCase()
  appInfo = appInfo || APP_INFO[name] || {}

  if ((name === 'qb' || name === 'ff') && isBackUrl) {
    if (isAndroid(window.navigator.userAgent)) {
      url = `${url},backurl=qb://home/feeds?tab=1`;
    } else {
      // url = `${url},backurl=qb://home/feeds?tabId=1`;
      url = `${url},backurl=`
    }
  }

  console.log('directDownload url', url)
  console.log('directDownload appInfo', appInfo)

  const runAppOption = {
    PosID: posId || appInfo.PosID, //端拉活posid
    ChannelID: myEnv.isQZone ? 'com.qzone' : (myEnv.isMQQ ? 'com.tencent.mobileqq' : (myEnv.isWeChat ? 'com.tencent.mm' : '')) //端拉活channelID
  }

  // TBS
  if (isTBS(window.navigator.userAgent) && window.tbs) {
    const tbsDownload = new TBSDownload(window.tbs, appInfo.downloadUrl, appInfo.pkgName, url)
    const state = tbsDownload.getState()
    switch (state) {
      case 'installed':
        tbsDownload.runApp(runAppOption)
        reportUg(7, subpos);
        // 已安装-调起应用上报
        statTicket({
          user_action: 'sharelp_live_run_app',
          ...statData
        })
        break;
      case 'downloading':
        if (!isNeedPause) return
        tbsDownloadPause = true
        tbsDownload.pauseDownload()
        store.dispatch(actions.downloadBar.loadDownLoadStatus('downloadcanceled'))
        reportUg(22, subpos);
        // 本地无包-暂停下载上报
        statTicket({
          user_action: 'sharelp_pause_download',
          ...statData
        })
        break;
      case 'downloaded':
        tbsDownload.startInstall()
        reportUg(20, subpos);
        reportUg(102, subpos);
        // 本地有安装包-调起安装面板上报
        statTicket({
          user_action: 'sharelp_tune_up_install_package',
          ...statData
        })
        // 本地有包-调起安装面板-时间戳
        tbsDataReport.startInstallPackageTime = new Date().getTime()
        const installTimer = setInterval(() => {
          const newState = tbsDownload.getState()
          console.log('newState', newState)
          store.dispatch(actions.downloadBar.loadDownLoadStatus(newState))
          if (newState === 'installed') {
            //report(19);
            // 本地有包-完成安装上报
            statTicket({
              user_action: 'sharelp_complete_install_package',
              ...statData,
              time_stamp: new Date().getTime() - tbsDataReport.startInstallPackageTime //上报耗时（ms）
            })
            reportUg(106, subpos);
            tbsDownload.runApp(runAppOption)
            // 本地有包-完成安装-调起应用上报
            statTicket({
              user_action: 'sharelp_installed_run_app_package',
              ...statData
            })
            clearInterval(installTimer);
          }

        }, 500);
        break;
      default:
        if (state === 'downloadcanceled') {
          // 本地无包-继续下载上报
          statTicket({
            user_action: 'sharelp_continue_download',
            ...statData
          })
        } else {
          reportUg(9, subpos);
          // 本地无包-开始下载上报
          statTicket({
            user_action: 'sharelp_start_download',
            ...statData
          })
          // 本地无包-开始下载-时间戳
          tbsDataReport.startDownloadTime = new Date().getTime()
        }
        tbsDownloadPause = false
        tbsDownload.startDownload()
        const downloadTimer = setInterval(() => {
          // 取消下载，清除下载计时器
          if (tbsDownloadPause) {
            clearInterval(downloadTimer)
            return
          }
          const newState = tbsDownload.getState()
          const progress = tbsDownload.getProgress()
          console.log('newState', newState, 'progress', progress)
          store.dispatch(actions.downloadBar.loadDownLoadStatus(newState))
          store.dispatch(actions.downloadBar.loadProgressValue(progress))
          // 下载完成，清除下载计时器；开始安装
          if (newState === 'downloaded') {
            //report(10)
            // 本地无包-完成下载上报
            statTicket({
              user_action: 'sharelp_complete_download',
              ...statData,
              time_stamp: new Date().getTime() - tbsDataReport.startDownloadTime //上报耗时（ms）
            })
            reportUg(20, subpos);
            tbsDownload.startInstall();
            // 本地无包-调起安装面板上报
            statTicket({
              user_action: 'sharelp_tune_up_install',
              ...statData
            })
            // 本地无包-调起安装面板-时间戳
            tbsDataReport.startInstallTime = new Date().getTime()
            clearInterval(downloadTimer)
            const installTimer = setInterval(() => {
              const newState = tbsDownload.getState()
              store.dispatch(actions.downloadBar.loadDownLoadStatus(newState))
              if (newState === 'installed') {
                // 本地无包-完成安装上报
                statTicket({
                  user_action: 'sharelp_complete_install',
                  ...statData,
                  time_stamp: new Date().getTime() - tbsDataReport.startInstallTime //上报耗时（ms）
                })
                reportUg(106, subpos);
                tbsDownload.runApp(runAppOption)
                // // 本地无包-完成安装-调起应用上报
                // statTicket({
                //   user_action: 'sharelp_installed_run_app',
                //   ...statData
                // })
                clearInterval(installTimer)
              }
            }, 500)
          }
        }, 200)
        break;
    }

  } else {
    // 非TBS
    const isInstall = await detectStatus(name);
    if (name === 'qb') {
      if (url.indexOf(",PosID=") <= -1 && url.indexOf(",ChannelID=") <= -1) {
        url = `${url},PosID=${runAppOption.PosID},ChannelID=${runAppOption.ChannelID}`
      }
    }
    if (isInstall) {
      const isOpen = get(window, OPEN_API[name]);
      if (isOpen && typeof isOpen === 'function') {
        isOpen({
          url
        })
        reportUg(7);
        // 非TBS-已安装-调起应用-上报
        statTicket({
          user_action: 'sharelp_not_tbs_run_app',
          ...statData
        })
      }
    } else {
      // alert(`即将在当前窗口打开${url}`);
      if (name !== 'qb') {
        window.location.href = url;
      }
      setTimeout(() => {
        reportUg(9);
        // 非TBS-未安装-跳转下载-上报
        statTicket({
          user_action: 'sharelp_not_tbs_goto_download',
          ...statData
        })

        // android-微信-场景拉新
        if (detectEnv().isWeChat) {
          console.log('false tbs wx download')
          if (detectEnv().isAndroid) {
            wxDownloadTask({ name })
          } else {
            wxDownloadApi({ name })
          }
        } else {
          window.location.href = APP_INFO[name].downloadUrlNotTBS;
        }
      }, 1000);
    }
  }
}

//跳转中间页下载
const redirctMiddlePage = ({ downMidPos = 'common', personalType, statInfo, name }) => {
  const pathnameParams = window.location.pathname.split('/');
  let type = null;
  switch (pathnameParams[2]) {
    case "news":
      type = "share_article"
      break;
    case "video":
      if (window.location.search.includes('classify=1')) {
        type = "share_mini_video"
      } else {
        type = "share_short_video"
      }
      break;
    case "backNews":
      type = "backNews"
      break;
    case "highShare":
      type = "highShare"
      break;
    case "shortContent":
      type = "shortContent"
      break;
    case "thirdShare":
      type = "thirdPage"
      break;
    default:
      break;
  }
  let { middlePageHooks, ugData: { statInfo: defaultStatInfo }, androidWechatDownloadUrl } = window._configs;
  let pageUrl = middlePageHooks.pageUrl;
  let stat = encodeURIComponent(statInfo?.[999]?.[0] || defaultStatInfo[999][0]);
  let appType = window.appName
  let url = ''
  console.log("redirctMiddlePage personalType", personalType)
  if (appType === 'extreme_qb' || appType === 'novel_qb' || appType === 'young_qb') {
    url = pageUrl.replace("${type}", appType).replace("${subpose}", downMidPos).replace("${stat}", stat);
  } else {
    url = pageUrl.replace("${type}", personalType || type).replace("${subpose}", downMidPos).replace("${stat}", stat);
  }

  //安卓微信TBS/非TBS调微信自带的下载中间页api
  if (detectEnv().isAndroid && detectEnv().isWeChat) {
    window.location.href = androidWechatDownloadUrl;
    // wxDownloadTask({name})
  } else {
    //其他环境调中间页
    window.location.href = url;
  }
}

const isIosFloatingActionButton = (myEnv, url, downMidPos) => (myEnv.isMQQ &&
  !myEnv.isAndroid &&
  url.indexOf("mttbrowser://url=") <= -1 &&
  !window.location.search.includes('classify=1') &&
  window.location.href.includes('video') &&
  downMidPos === "floating_action_button");


const getUlinkJumpUrl = (url, myEnv) => {
  const iOSDownloadUrl = 'https://itunes.apple.com/app/apple-store/id370139302?pt=69276&mt=8';
  const universalLinksUrl = `https://ug.html5.qq.com/base/ulink/jump?u=${encodeURIComponent(url)}&d=${encodeURIComponent(myEnv.isIos ? iOSDownloadUrl : '')}`;
  return universalLinksUrl;
};

export const downloadOrOpenApp = async ({
  name = 'qb',
  url = '',
  isBackUrl = true,
  appInfo = '',
  statData = {},
  posId,
  downMidPos = 'common',
  personalType,
  statInfo,
}) => {
  const urlQuery = parseUrl(window.location.href).query || {};
  const myEnv = detectEnv();
  name = name.toLocaleLowerCase();
  appInfo = appInfo || APP_INFO[name] || {};
  const noUrlHandling = url === APP_INFO[name].schemeMainTL;
  if ((name === 'qb' || name === 'ff' || name === 'extreme_qb' || name === 'novel_qb') && isBackUrl && !noUrlHandling) {
    if (isAndroid(window.navigator.userAgent)) {
      url = `${url},backurl=qb://home/feeds?tab=1`;
    } else {
      url = `${url},backurl=qb://home/feeds?tabId=1`;
    }
  }

  if (urlQuery.debug) {
    lclog.info('downloadOrOpenAppUrlAppInfo', name, url, appInfo, myEnv, urlQuery, navigator.userAgent);
  }
  const runAppOption = {
    PosID: posId || appInfo.PosID,
    ChannelID: myEnv.isQZone ? 'com.qzone' : (myEnv.isMQQ ? 'com.tencent.mobileqq' : (myEnv.isWeChat ? 'com.tencent.mm' : ''))
  }

  // TBS
  if (isTBS(window.navigator.userAgent) && window.tbs) {
    //添加拉起对应app的协议
    if (name === 'extreme_qb') {
      url = `${APP_INFO?.["extreme_qb"]?.scheme}url=${url}`
    } else if (name === 'novel_qb') {
      url = `${APP_INFO?.["novel_qb"]?.scheme}url=${url}`
    } else if (name === 'young_qb') {
      url = `${APP_INFO?.["young_qb"]?.scheme}url=${url}`
    }
    console.log('downloadOrOpenApp tbs url', url);
    const tbsDownload = new TBSDownload(window.tbs, appInfo.downloadUrl, appInfo.pkgName, url);
    const state = tbsDownload.getState();
    console.log('state', state)
    switch (state) {
      case 'installed':
        tbsDownload.runApp(runAppOption);
        reportUg(7);
        // 已安装-调起应用上报
        statTicket({
          user_action: 'sharelp_live_run_app',
          ...statData
        });
        break;
      default:
        redirctMiddlePage({ downMidPos, personalType, statInfo, name });
    }
  } else {
    // 非TBS
    if (name === 'qb') {
      if (url.indexOf(",PosID=") <= -1 && url.indexOf(",ChannelID=") <= -1) {
        url = url.indexOf('search_result') > -1 ? url : `${url},PosID=${runAppOption.PosID},ChannelID=${runAppOption.ChannelID}`
      }
    } else if (name === 'young_qb') {
      //兼容IOS bingo无法判断安装状态
      const isOpen = get(window, OPEN_API[name]);
      if (myEnv.isMQQ) {
        isOpen({
          url,
          noUrlHandling
        })
        let time = setTimeout(() => {
          redirctMiddlePage({ downMidPos, personalType, statInfo, name });
        }, 2500)
        document.addEventListener("visibilitychange", () => {
          if (document.hidden) {
            clearTimeout(time)
          }
        })
      } else {
        isOpen({
          url,
          noUrlHandling
        }, (res) => {
          if (!res) {
            redirctMiddlePage({ downMidPos, personalType, statInfo, name });
          }
        })
      }
      return
    }
    const isInstall = await detectStatus(name);
    if (urlQuery.debug) {
      lclog.info('downloadOrOpenAppIsInstall', isInstall);
    }

    // 先处理企业微信的情况，比较特殊，企业微信中无法得知用户是否安装 qb，所以只有 iOS 可以用 universal link 拉起 qb，其它情况暂时没有办法
    if (myEnv.isWxwork) {
      if (myEnv.isIos) {
        const universalLinksUrl = getUlinkJumpUrl(url, myEnv);
        if (urlQuery.debug) {
          lclog.info('downloadOrOpenIsWxwork', universalLinksUrl);
        }
        window.location.href = universalLinksUrl;
      } else {
        redirctMiddlePage({ downMidPos, personalType, statInfo, name });
      }
    } else if (isInstall) {
      const isOpen = get(window, OPEN_API[name]);

      //资讯悬浮球短视频IOS拉活承接
      if (isIosFloatingActionButton(myEnv, url, downMidPos)) {
        let jumpUrl = `mttbrowser://url=${url}`;
        window.location.href = jumpUrl;
        reportUg(7);
        return;
      }

      if (urlQuery.debug) {
        lclog.info('downloadOrOpenAppUrl', isOpen && typeof isOpen === 'function', url);
      }

      if (myEnv.isMQQ && myEnv.isAndroid && noUrlHandling) {
        window.location.href = url;
        reportUg(7);
        return;
      } else if (isOpen && typeof isOpen === 'function') {
        try {
          isOpen({
            url,
            noUrlHandling
          }, (res) => {
            if (urlQuery.debug) {
              lclog.info('downloadOrOpenAppIsOpenRes', res);
            }

            if (!res && (myEnv.isIos)) {
              const universalLinksUrl = getUlinkJumpUrl(url, myEnv);
              if (urlQuery.debug) {
                lclog.info('downloadOrOpenAppUniversalLinks', universalLinksUrl);
              }
              window.location.href = universalLinksUrl;
            } else if (!res) {
              redirctMiddlePage({ downMidPos, personalType, statInfo, name });
            }
          });
          reportUg(7);
          // 非TBS-已安装-调起应用-上报
          statTicket({
            user_action: 'sharelp_not_tbs_run_app',
            ...statData
          });
        } catch (err) {
          lclog.error('downloadOrOpenAppIsOpenCatch', err);
          redirctMiddlePage({ downMidPos, personalType, statInfo, name });
        }
      }
    } else {
      if (name !== 'qb' && name !== 'extreme_qb' && name !== 'novel_qb' && name !== 'young_qb') {
        window.location.href = url;
      }
      statTicket({
        user_action: 'sharelp_not_tbs_goto_download',
        ...statData
      });
      redirctMiddlePage({ downMidPos, personalType, statInfo, name });
    }
  }
};

